import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=b8c31674&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=ts"
export * from "./Supplier.vue?vue&type=script&lang=ts"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=b8c31674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c31674",
  null
  
)

export default component.exports